import { render, staticRenderFns } from "./TransportationLinesAddNew.vue?vue&type=template&id=c8612614"
import script from "./TransportationLinesAddNew.vue?vue&type=script&lang=js"
export * from "./TransportationLinesAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports